import { __assign } from "tslib";
// DS: I139
// from GDrive
import React from 'react';
import IconWrap from '../../IconWrap';
var DailyDeviation = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M18 3a1 1 0 011 1v15.674a1 1 0 01-1.275.962L12 19l-5.725 1.636A1 1 0 015 19.674V4a1 1 0 011-1h12zm-3 3h-1.763l-.175.183-.832 1.635-.262.182H9v2.497h1.632l.145.181L9 14.182V16h1.763l.176-.183.831-1.635.262-.182H15v-2.497h-1.632l-.145-.183L15 7.818V6z", fillRule: "evenodd" }))));
};
DailyDeviation.displayName = 'DailyDeviation';
export default DailyDeviation;
//# sourceMappingURL=DailyDeviation.js.map